/** 1.3.0 portal strings, stream P4 (decisions and comments the supplier sees; email.portal_item_rejected.*, _submission_accepted.*, _submission_rejected.*, _staff_comment.*, and the reviewers' email.intake_*.*). P4's file. */
export const INTAKE_STRINGS = {
  // What the supplier sees of a decision (the portal app shows these beside an item or a submission).
  'intake.decision.accepted': 'Accepted',
  'intake.decision.rejected': 'Rejected: {reason}',
  'intake.decision.waived': 'Not needed any more',
  'intake.decision.reopened': 'Open again',
  'intake.submission.accepted': 'Accepted into the library',
  'intake.submission.acceptedMissing': 'Accepted. Some requested items are still open: upload them when they are ready.',
  'intake.submission.rejected': 'Rejected: {reason}',

  // Supplier emails.
  'email.portal_item_rejected.subject': '{portalName}: {item} for “{title}” needs changes',
  'email.portal_item_rejected.body': 'Hello {name},\n\n“{item}” for “{title}” was not accepted:\n\n{reason}\n\nUpload a new file when it is ready:\n{link}\n\n— {portalName}',
  'email.portal_submission_accepted.subject': '{portalName}: “{title}” was accepted',
  'email.portal_submission_accepted.body': 'Hello {name},\n\nThank you: “{title}” was accepted.\n\n{link}\n\n— {portalName}',
  'email.portal_submission_rejected.subject': '{portalName}: “{title}” was not accepted',
  'email.portal_submission_rejected.body': 'Hello {name},\n\n“{title}” was not accepted:\n\n{reason}\n\n{link}\n\n— {portalName}',
  'email.portal_staff_comment.subject': '{portalName}: a comment on “{title}”',
  'email.portal_staff_comment.body': 'Hello {name},\n\nThere is a new comment on “{title}”:\n\n{comment}\n\nReply in the portal:\n{link}\n\n— {portalName}',

  // Reviewer emails (members, topic "intake").
  'email.intake_waiting.subject': 'Intake: “{title}” from {company} is waiting for review',
  'email.intake_waiting.body': '“{title}” from {company} is waiting for review in Intake.',
  'email.intake_supplier_reply.subject': 'Intake: {company} replied on “{title}”',
  'email.intake_supplier_reply.body': '{author} from {company} wrote on “{title}”: {comment}',
  'email.intake_overdue_digest.subject': 'Intake: {count} overdue deliveries',
  'email.intake_overdue_digest.body': 'These deliveries are past their due date: {list}',
  'email.intake_withdrawn.subject': 'Intake: {company} withdrew “{title}”',
  'email.intake_withdrawn.body': '{company} withdrew “{title}” before it was reviewed.',
  'email.intake.action': 'Open in Intake',
  'email.intake.footer': 'You get this because you review media portal uploads. Change it under your account → Email notifications (Intake).',
} as const;
